// extracted by mini-css-extract-plugin
export default {"slide":"beforeAfter_slide__TI3vp","image":"beforeAfter_image__1a2D+","side":"beforeAfter_side__s9yL7","label":"beforeAfter_label__zAJwJ"};